"use client";

import clsx from "clsx";

interface OfferedByProps {
  ownerName?: string | null;
  ownerLogoUrl?: string | null;
  disclosureUrl?: string | null;
  className?: string;
}

/**
 * OfferedBy
 *
 * Third-party strategy attribution block: owner logo (if provided), "Offered
 * by {ownerName}", and — when set — a link to the CFTC Part 4 disclosure
 * document. Callers gate visibility with `strategy.ownerType === "third_party"`.
 */
export const OfferedBy = ({
  ownerName,
  ownerLogoUrl,
  disclosureUrl,
  className,
}: OfferedByProps) => {
  return (
    <div
      className={clsx(
        "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-700/50 bg-slate-800/50 px-4 py-3",
        className
      )}
    >
      <div className="flex items-center gap-3">
        {ownerLogoUrl && (
          <img
            src={ownerLogoUrl}
            alt={ownerName ?? "Strategy owner"}
            className="h-8 w-8 rounded-full object-cover"
          />
        )}
        <span className="text-sm text-slate-400">
          Offered by{" "}
          <span className="font-semibold text-white">
            {ownerName || "Third-party provider"}
          </span>
        </span>
      </div>

      {disclosureUrl && (
        <a
          href={disclosureUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-medium text-blue-400 transition hover:text-blue-300 hover:underline"
        >
          View CFTC Part 4 disclosure
        </a>
      )}
    </div>
  );
};
